import script from "./AppSwiperButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwiperButton.vue?vue&type=script&setup=true&lang=js"

import "./AppSwiperButton.vue?vue&type=style&index=0&id=c10883ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c10883ae"]])

export default __exports__